import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { Badge } from '@calendly/ui/components/badge';
import { BareButton } from '@calendly/ui/components/bare-button';
import { Button } from '@calendly/ui/components/button';
import { AiSparkleFilledIcon, VideoIcon } from '@calendly/ui/components/icons';
import { Link } from '@calendly/ui/components/link';
import { BodyText, TitleText } from '@calendly/ui/components/typography';
import { spacing0_125x } from '@calendly/ui/spacing';
import { CTA_KEY, trackCallieHeroWatchHowItWorksClicked } from 'components/home/ai_assistant_banner/analytics';
import { CALLIE_LEARN_MORE_HELP_URL } from 'components/home/ai_assistant_banner/constants';
import { useWatchHowItWorksOverlay } from 'components/home/ai_assistant_banner/onboarding/use_watch_how_it_works_overlay';
import { useTrack } from 'hooks/analytics_events';
import heroImage from './media/callie-video.png';
const heroCss = "h6yxo9c";
const thumbButtonCss = "trxagzy";
const thumbCss = "td299va";
const copyCss = "c1oabdiw";
const titleCss = "t1d4rht6";
const copyRowCss = "c154h0cp";
export const CallieHero = ({
  isCallieDisabled
}) => {
  const track = useTrack();
  const {
    openWatchHowItWorksOverlay,
    watchHowItWorksOverlay
  } = useWatchHowItWorksOverlay({
    ctaKey: CTA_KEY.CALLIE_HERO
  });
  const watchCtaLabel = I18n.t('publisher.home.scheduling_subsection.callie.hero.video_cta');
  const handleWatchHowItWorksClick = () => {
    trackCallieHeroWatchHowItWorksClicked(track);
    openWatchHowItWorksOverlay();
  };
  return <>
      <section className={heroCss} data-testid="callie-hero">
        <BareButton aria-label={watchCtaLabel} className={thumbButtonCss} data-testid="callie-hero-watch-video-thumb" type="button" onClick={handleWatchHowItWorksClick}>
          <img className={thumbCss} src={heroImage} alt="" />
        </BareButton>
        <div className={copyCss}>
          <div className={copyRowCss}>
            <div className={titleCss}>
              <AiSparkleFilledIcon useGradient />
              <TitleText level="2" size="medium">
                {I18n.t('publisher.home.scheduling_subsection.callie.hero.title')}
              </TitleText>
              <Badge type="new">
                {I18n.t('publisher.home.scheduling_subsection.callie.hero.beta_badge')}
              </Badge>
              {isCallieDisabled && <Badge type="error">{I18n.t('publisher.personal_settings.scheduling_assistant.disabled.badge_label')}</Badge>}
            </div>
            <BodyText>
              {HtmlParser(I18n.t('publisher.home.scheduling_subsection.callie.hero.description'))}
              <BodyText inline>{' '}</BodyText>
              <Link href={CALLIE_LEARN_MORE_HELP_URL} underline={false} target="_blank" rel="noopener noreferrer">
                <BodyText inline>
                  {I18n.t('publisher.home.ai_assistant_banner.learn_more')}
                </BodyText>
              </Link>
            </BodyText>
          </div>
          <div>
            <Button decoration="secondary-outline" size="medium" onClick={handleWatchHowItWorksClick}>
              <VideoIcon size="standard" spacingRight={spacing0_125x} />
              {watchCtaLabel}
            </Button>
          </div>
        </div>
      </section>
      {watchHowItWorksOverlay}
    </>;
};

require("./callie_hero.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./callie_hero.js");